class AjaxPaginate extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.cache = new Map();
  }

  connectedCallback() {
    this.#setupListeners();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
    window.removeEventListener('popstate', this.popStateHandler);
  }

  #setupListeners() {
    this.clickHandler = this.#handleClick.bind(this);
    this.popStateHandler = this.#handlePopState.bind(this);
    this.addEventListener('click', this.clickHandler);
    window.addEventListener('popstate', this.popStateHandler);
  }

  #handleClick(event) {
    const selectors = [
      'a.pagination__item',
      'a.blog-filter__pill',
      'a.report-card__tag',
      'a.article-card-library__tag'
    ].join(', ');

    const link = event.target.closest(selectors);
    if (!link || !this.contains(link)) return;

    event.preventDefault();
    const url = link.href;

    this.#renderPage(url);
  }

  #handlePopState(event) {
    // If we have a cached state for the URL that is being popped, render it, or fetch the current URL.
    this.#renderPage(window.location.href, false);
  }

  async #renderPage(url, updateHistory = true) {
    try {
      this.classList.add('is-loading');
      this.style.opacity = '0.5';
      this.style.pointerEvents = 'none';

      let html;

      // Ensure the URL correctly requests the section markup
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      const urlString = fetchUrl.toString();

      if (this.cache.has(urlString)) {
        html = this.cache.get(urlString);
      } else {
        const response = await fetch(urlString);
        if (!response.ok) throw new Error('Network response was not ok');

        const responseText = await response.text();
        html = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('ajax-paginate')?.innerHTML;

        if (html) {
          this.cache.set(urlString, html);
        } else {
          throw new Error('No ajax-paginate element found in response');
        }
      }

      if (html) {
        this.innerHTML = html;

        if (updateHistory) {
          history.pushState({ path: url }, '', url);
        }

        // Scroll to the blog-articles block smoothly
        const targetBlock = document.querySelector('.blog-articles') || this;
        const offsetTop = targetBlock.getBoundingClientRect().top + window.scrollY - 100; // 100px buffer for sticky header (adjustable)
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    } catch (error) {
      console.error('Error fetching pagination:', error);
      // Fallback to standard navigation on error
      if (updateHistory) {
         window.location.href = url;
      }
    } finally {
      this.classList.remove('is-loading');
      this.style.opacity = '';
      this.style.pointerEvents = '';
    }
  }
}

if (!customElements.get('ajax-paginate')) {
  customElements.define('ajax-paginate', AjaxPaginate);
}
